import React, { PureComponent } from 'react'
import { IconComponent, JumpHotAreaComponent, PictureProgress } from '../../components'

const componentMap = {
  icon: IconComponent,
  image_progress: PictureProgress,
  jumpable: JumpHotAreaComponent
}

class Message extends PureComponent {
  static renderLayer = ({ childKey, ...restArgs }) => {
    const Component = componentMap[childKey]
    if (Component && Component.renderLayer) {
      Component.renderLayer({ childKey, ...restArgs })
    }
  }

  static removeLayer = ({ childKey, ...restArgs }) => {
    const Component = componentMap[childKey]

    if (Component && Component.removeLayer) {
      Component.removeLayer({ childKey, ...restArgs })
    }
  }

  render() {
    const { childKey, propMap } = this.props
    const prop = propMap[childKey] || {}
    const Component = componentMap[childKey]
    const allProps = { ...this.props, ...prop }

    return <div className="control-container">{Component && <Component {...allProps} />}</div>
  }
}

export default Message
